import React, { Component } from 'react'
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
import IconRender from '../std/IconRender';
import HelperCriteriaCalculator from '../../helpers/HelperCriteriaCalculator';


class ServiceCalc extends Component {

	constructor(props) {
		super(props);
		this.onChange = props.onChange;
		this.state = ServiceCalc.getStateFromProps(props, false);
		this.mandatory = props.mandatory;
	}

	componentDidMount() {
		const svcKey = this.props.pckCode ? `${this.props.pckCode}-${this.props.code}` : this.props.code;
		const tooltipTriggerNode = document.querySelector(`#infoService_${svcKey}`);
		if (tooltipTriggerNode) {
			new bootstrap.Tooltip(tooltipTriggerNode);
		}
	}

	static getStateFromProps(props, open) {
		return {
			selected: props.selected,
			selectable: props.selectable,
			mapSelected: props.mapSelected,
			open: open
		};
	}

	static getDerivedStateFromProps(props, currentState) {
		if (currentState.selected !== props.selected
			|| currentState.selectable !== props.selectable
			|| currentState.mapSelected !== props.mapSelected
		) {
			return ServiceCalc.getStateFromProps(props, currentState.open);
		}
		return null
	}
	handleChangeCheckBox = event => {
		var selected = event.target.checked === true;
		this.handleChanged(selected);
	};
	handleClickItem = () => {
		var selected = !this.state.selected;
		this.handleChanged(selected);
	};
	handleChanged = (checked) => {
		var selected = checked || this.mandatory;
		if (this.props.packageSelected !== undefined) {
			selected = selected && this.props.packageSelected;
		}
		var mapSelected = this.state.mapSelected;
		for (var key in this.props.subServices) {
			var service = this.props.subServices[key];
			if (selected && service.mandatory) {
				mapSelected[HelperCriteriaCalculator.getFlatSvcKey(service.serviceCode,this.props.code)].selected = true;
			} else if (!selected) {
				mapSelected[HelperCriteriaCalculator.getFlatSvcKey(service.serviceCode,this.props.code)].selected = false;
			}
		}
		selected = selected === true;
		this.setState({ mapSelected: mapSelected });
		this.setState({ selected: selected });
		this.onChange(this.props.code, selected);
	}

	handleExpand = () => {
		if (this.props.subServices != null && this.props.subServices.length > 0) {
			this.setState(state => ({ open: !state.open }));
		}
	}

	render() {
		const svcKey = this.props.pckCode ? `${this.props.pckCode}-${this.props.code}` : this.props.code;
		const isFather = this.props.subServices != null && this.props.subServices.length > 0;
		const styleNested = {};
		return (
			<React.Fragment>
				{this.props.selectable &&
					<li className="list-group-item" style={styleNested}>
						<div className="form-check">
							<input className="form-check-input mt-2" type="checkbox" checked={this.props.selected} value={this.props.code} onChange={this.handleChangeCheckBox}
								id={`flexCheckService${this.props.code}`} />
							<label className="form-check-label" htmlFor={`flexCheckService${this.props.code}`}>
								{this.props.label}
							</label>
							{this.state.open ?
								isFather && <button className='btn btn-link' onClick={this.handleExpand} ><IconRender name="chevron-up" /></button>
								: isFather && <button className='btn btn-link' onClick={this.handleExpand} ><IconRender name="chevron-down" /></button>
							}
							{this.props.info != null && this.props.info.length !== 0
								&& <button className='btn btn-link' data-bs-toggle="tooltip"
									id={`infoService_${svcKey}`} data-bs-title={this.props.info}>
									<IconRender name="info-circle-fill" />
								</button>
							}
						</div>
						{isFather && this.state.open && <ul className="list-group list-group-flush">
							{this.props.subServices.map((service, index) => (
								<ServiceCalc
									code={service.serviceCode}
									pckCode={this.props.code}
									label={service.label}
									info={service.description}
									mandatory={service.mandatory}
									packageSelected={this.state.selected}
									selected={this.state.mapSelected[HelperCriteriaCalculator.getFlatSvcKey(service.serviceCode,this.props.code)].selected}
									selectable={this.state.mapSelected[HelperCriteriaCalculator.getFlatSvcKey(service.serviceCode,this.props.code)].selectable}
									key={index}
									onChange={this.onChange}
									level={2}
									onOpenInfo={this.props.onOpenInfo}
								/>
							))}
						</ul>
						}
					</li>
				}
			</React.Fragment>
		)
	}
}

export default ServiceCalc

